/**
 * @desc 获取需求月份
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.demandOrder.getDemandMonth.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/getDemandMonth`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
